export default "__VITE_ASSET__8254acdb__"